import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {semanticColor, sizing} from "@khanacademy/wonder-blocks-tokens";
import {Heading} from "@khanacademy/wonder-blocks-typography";

interface Props {
    header: string;
    children: React.ReactNode;
    testId?: string;
    ariaLabel?: string;
    id?: string;
    footer?: React.ReactNode;
    style?: React.CSSProperties;
    footerStyle?: React.CSSProperties;
}

export const Section: React.FC<Props> = ({
    header,
    testId,
    ariaLabel,
    id,
    children,
    footer,
    style,
    footerStyle,
}) => {
    return (
        <View
            id={id}
            role="region"
            aria-label={ariaLabel ?? header}
            data-testid={testId ?? "section"}
            style={[styles.container, style]}
        >
            <Heading tag="h2" size="large" weight="bold" style={styles.header}>
                {header}
            </Heading>
            <View>{children}</View>
            {footer && (
                <View style={[styles.footer, footerStyle]}>{footer}</View>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        background: semanticColor.core.background.base.default,
        border: `1px solid ${semanticColor.core.border.neutral.subtle}`,
        borderRadius: sizing.size_080,
        padding: sizing.size_320,
        width: "100%",
        maxWidth: 800,
    },
    header: {
        marginBlockEnd: sizing.size_160,
    },
    footer: {
        marginBlockStart: sizing.size_160,
    },
});
